<h5 *ngIf="showTitle">
    <strong>{{ 'queryForm.queryVariables.stepTitle' | translate }} {{stepIndex}}: </strong>
    {{ 'queryForm.queryVariables.queryVariables' | translate }}
</h5>
<div class="query-variables mb-4">
    <nz-radio-group class="list-category" [(ngModel)]="selectedCategory" [ngModelOptions]="{standalone: true}" (ngModelChange)="searchVariableByCategory()">
        <label class="item-category" nz-radio-button [nzValue]="allCategory">
            <span class="d-flex align-items-center">
                <i class="fa fa-search icon-search"></i>
                <span class="text-nowrap">{{ 'queryForm.queryVariables.searchAll' | translate }}</span>
                <span class="item-category-badge">
                    {{ variableSelectedList?.length }}/{{ fieldList.length }}
                </span>
            </span>
        </label>
        <label class="item-category" nz-radio-button *ngFor="let category of categoryList" [nzValue]="category">
            <span class="d-flex align-items-center">
                <span class="text-nowrap">{{ category.name }}</span>
                <span class="item-category-badge">
                    {{ category.selectedItemCount }}/{{ category.itemCount }}
                </span>
            </span>
        </label>
    </nz-radio-group>
    <div class="row variable-selector">
        <div class="col-md-6 col-12 order-lg-1 order-2">
            <div class="my-2 d-flex justify-content-start align-items-center">
                <h4 class="m-0">{{ 'queryForm.queryVariables.select' | translate }}</h4>
                <button class="ml-2 d-flex align-items-center" type="button" nz-button nzType="text" (click)="selectAllVariables()">
                    <span nz-icon nzType="check-square" nzTheme="outline"></span>
                    {{ 'queryForm.queryVariables.selectAll' | translate }}
                </button>
            </div>
            <input class="search-bar" nz-input type="text" [(ngModel)]="searchInput" [ngModelOptions]="{standalone: true}" placeholder="{{ 'queryForm.queryVariables.searchPlaceholder' | translate }}" (input)="searchVariableByName()"/>
            <div class="list-variable">
                <div *ngFor="let variableToSelect of variableToSelectList">
                    <button class="item-variable" type="button" nz-button nzType="text" (click)="selectVariable(variableToSelect)">
                        <i class="fa fa-circle-o icon-to-select"></i>
                        {{ variableToSelect.fieldName || variableToSelect.fieldKey }}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-12 order-lg-2 order-1">
            <div class="my-2 d-flex justify-content-start align-items-center">
                <h4 class="m-0">{{ 'queryForm.queryVariables.selected' | translate }}</h4>
                <button class="ml-2 d-flex align-items-center" type="button" nz-button nzType="text" (click)="unselectAllVariables()">
                    <span nz-icon nzType="border" nzTheme="outline"></span>
                    {{ 'queryForm.queryVariables.clearAll' | translate }}
                </button>
                <span class="flex-grow-1"></span>
                <h4 class="m-0">({{ variableSelectedList?.length }})</h4>
            </div>
            <div class="list-variable">
                <div *ngFor="let variableSelected of variableSelectedList">
                    <button class="item-variable" type="button" nz-button nzType="text" (click)="unselectVariable(variableSelected)">
                        <i class="fa fa-check-circle icon-selected"></i>
                        {{ variableSelected.fieldName || variableSelected.fieldKey }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
